import { Button } from '@/components/_ui/Button'
import T from '@/components/Helpers/Translate'
import { useGetOrderDetailsBeforeOrderCalculation } from '@/lib/hooks/helpers/order/useGetOrderDetailsBeforeOrderCalculation'
import { usePriceHandler } from '@/lib/hooks/helpers/usePriceHandler'
import useClientRedirect from '@/lib/hooks/routing/useRedirect'
import useGlobalStore from '@/store/useGlobalStore'
import { DistributorOnly } from '@/components/Helpers/DistributorOnly'
import { useFocusMode } from '@/lib/hooks/helpers/useFocusMode'
import CartSheetSavings from '../CartSheetSavings'

const CartSheetFooter = () => {
  const {
    setApp,
    cart,
    app: { marketExceptions },
  } = useGlobalStore()
  const { clientRedirect } = useClientRedirect()
  const { priceHandler } = usePriceHandler()
  const { isFocusMode } = useFocusMode()

  const cartItems = [...cart.otp, ...cart.subscribe]

  const { orderDetailsBeforeOrderCalculation } =
    useGetOrderDetailsBeforeOrderCalculation()

  const handleToCheckout = async ({ queryString = '' } = {}) => {
    setApp({ isCartOpen: false })

    await clientRedirect.to({
      path: `/checkout?${queryString}`,
    })
  }

  const getOrderSubTotal = () => {
    const { subtotal, discounts, taxes } = orderDetailsBeforeOrderCalculation

    if (
      marketExceptions?.tax?.inclusive &&
      marketExceptions?.tax?.noFrontendTaxCalculation
    ) {
      return subtotal - discounts
    }

    return marketExceptions?.tax?.inclusive
      ? subtotal - discounts + taxes
      : subtotal - discounts
  }

  const getOrderTotalPv = () => orderDetailsBeforeOrderCalculation.totalPV

  return (
    <div className="sticky bottom-0 border-t-2 border-t-slate-200 bg-white p-5 pb-0">
      <CartSheetSavings />
      <div className="flex flex-col p-5 pb-0">
        {marketExceptions?.tax?.inclusive && (
          <div className="flex justify-between text-sm">
            <span>
              <T>VAT</T>
            </span>

            <span>
              {priceHandler({
                price: orderDetailsBeforeOrderCalculation.taxes,
              })}
            </span>
          </div>
        )}
        <div className="flex justify-between font-semibold text-primary">
          <span>
            <T>subtotal</T>
          </span>

          <span>
            {priceHandler({
              price: getOrderSubTotal(),
            })}
          </span>
        </div>

        <DistributorOnly>
          <div className="flex justify-between text-primary">
            <span>
              <T>total_pv</T>
            </span>

            <span>{getOrderTotalPv()}</span>
          </div>
        </DistributorOnly>
        <Button
          disabled={cartItems.length === 0}
          onClick={() => {
            const queryString = isFocusMode ? 'focus=true' : ''

            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            handleToCheckout({ queryString })
          }}
          className="m-auto mt-5 w-[80%] rounded-full bg-secondary"
          data-test="cart-checkout-button"
        >
          <T>checkout</T>
        </Button>
        <Button
          onClick={() => {
            setApp({ isCartOpen: false })
          }}
          className="m-auto mt-2 w-[80%] rounded-full"
          variant="ghost"
          data-test="cart-continue-shopping-button"
        >
          <T>continue_shopping</T>
        </Button>
      </div>
    </div>
  )
}

export default CartSheetFooter
